import { useEffect } from 'react'
import { Route, Routes, useNavigate } from 'react-router-dom'
import { useFeaturesConfig } from 'builder/hooks/featureConfig/useFeaturesConfig'

import { Loading } from './Loading/Loading'
import { Onboarding } from './Onboarding/Onboarding'
import { Variant } from './types'

export const ProvisionUsers = () => {
  const navigate = useNavigate()
  const { features } = useFeaturesConfig()
  const variant = features?.trLeadsV2

  useEffect(() => {
    if (variant === 'a') {
      navigate('/resumes')
    }
  }, [variant, navigate])

  return (
    <Routes>
      <Route path="loading" element={<Loading />} />
      <Route path="onboarding" element={<Onboarding variant={variant as Variant} />} />
    </Routes>
  )
}
